import { GENDER } from '@/common/constants'

export default {
  title: 'Chamada de Vídeo',
  price: '{price}/min',
  remoteUserLeft: 'O usuário remoto saiu da chamada',
  missingRoomInfo: 'Informações da chamada estão faltando, tente novamente.',
  timeout: 'Sem resposta',
  refused: 'A chamada foi recusada',
  invite: {
    text: 'Você foi convidado para uma chamada de vídeo',
    cancel: 'cancelar({seconds}s)',
  },
  call: {
    waiting: 'Aguardando a outra pessoa atender...',
    autoCancel: 'Cancelamento automático({seconds}s)',
    costLabel: 'Custo da chamada de vídeo:',
  },
  cannotCallTips: {
    inRoom: 'Ocupado, a outra pessoa está no quarto',
    busy: `{gender, select,
      ${GENDER.MALE} {Ele está ocupado.}
      ${GENDER.FEMALE} {Ela está ocupada.}
      other {Ele/Ela está ocupado.}}`,
  },
  error: {
    insufficientCoins: {
      title: 'Moedas Insuficientes',
      message: 'Você não tem moedas suficientes para fazer esta chamada. Por favor, recarregue primeiro.',
      recharge: 'Recarregar Agora',
    },
    insufficientIntimacy: {
      title: 'Intimidade Insuficiente',
      message: 'Seu nível de intimidade com este usuário não é alto o suficiente para fazer uma chamada de vídeo.',
    },
    emptyBroadcastPenalty: {
      title: 'Chamada Restrita',
      message: 'Você está temporariamente restrito de fazer chamadas devido à punição do sistema de âncora.',
    },
    requireRealName: {
      title: 'Verificação Necessária',
      message: 'Complete a verificação de nome real antes de fazer chamadas de vídeo.',
      verify: 'Verificar Agora',
    },
    unknown: 'Falha ao iniciar chamada. Tente novamente mais tarde.',
    invalidCallInfo: 'Informações de chamada inválidas',
    answerFailed: 'Falha ao atender',
    publishFailed: 'Falha ao publicar vídeo',
    noRoomInfo: 'Falha ao obter informações da sala',
    noRtcConfig: 'Falha ao obter configuração RTC',
    joinFailed: 'Falha ao entrar na sala',
  },
  browserNotSupported: 'Seu navegador não suporta chamadas de vídeo',
  deviceNotFound: 'Câmera ou microfone não encontrado',
  matchFailed: 'Falha na correspondência, tente novamente mais tarde',
  matchTimeout: 'Tempo limite de correspondência esgotado, tente novamente',
  hangUpTips: 'Tem certeza que deseja encerrar a chamada de vídeo?',
  giftMessage: {
    sent: 'enviou',
    to: 'para',
  },
  callTimerLabel: {
    match: 'partida',
    privateCall: 'Chamada privada',
  },
  chargeWarning: 'A chamada será cobrada em {remaining}s.',
  remainVideoTime: 'Tempo de vídeo restante',
}
